module.exports = __webpack_public_path__ + "static/media/Inclined-Kids5.fed0dede.jpg";